export type ReportView = 'insights' | 'classic';

export const DEFAULT_REPORT_VIEW: ReportView = 'insights';

export const resolveViewFromSearch = (search: string): ReportView | null => {
  const params = new URLSearchParams(search);
  const view = params.get('view');
  if (view === 'insights' || view === 'classic') {
    return view;
  }
  return null;
};
